export const lineWidthValues = [1, 2, 3, 4, 5];
export const presetToolbarColors = ["#e5e5e5", "#d4d4d4", "#737373", "#404040", "#171717", "#000000"];
